import React, { Component } from 'react';
import '../App.css';

import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
// import Onboard from '../Common/Onboard/Onboard';
import ContactUs from '../Common/ContactUs/ContactUs';
import Social from '../Common/Social/Social';


class Layout extends Component {
    constructor(props) {
        super(props);
        
        this.year = (new Date()).getFullYear();
    }

    render() {
        return(
            <div className="App">
                {/* https://react-bootstrap.github.io/components/navbar/#navbars-form */}
                {/* <HeaderSimple/> */}
                <Header/>

                <Container>
                    {/* <Onboard/> */}

                    { this.props.children }

                    <div className="mt-5 mb-5 text-center">
                        <div className="mt-5 mb-5"><br/></div>
                        <ContactUs/>
                        <div className="mb-3"><br/></div>
                        <Social/>
                    </div>
                </Container>

                <div className="text-center small-font mt-2 mb-2">
                    Edge Poker &copy; {this.year} Stockenja. All Rights Reserved
                </div>
            </div>
        );
    }
}

export default Layout;